Vue.component('ow-modal', {
  _scopeId: 'data-v-32bfb7e2',
  owCSS: `.ow-modal-mask[data-v-32bfb7e2]{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.7);display:table;transition:opacity .3s ease;z-index:1004!important}.trans-bg[data-v-32bfb7e2]{background-color:transparent}.ow-modal-wrapper[data-v-32bfb7e2]{height:100%;display:table-cell;vertical-align:middle}.ow-modal-container[data-v-32bfb7e2]{margin:0 auto;padding:0;background-color:#000;border-radius:2px;box-shadow:0 2px 8px rgba(0,0,0,.33);transition:all .3s ease}.top[data-v-32bfb7e2]{vertical-align:top}.top .ow-modal-container[data-v-32bfb7e2]{margin-top:0}.middle[data-v-32bfb7e2]{vertical-align:middle}.bottom[data-v-32bfb7e2]{vertical-align:bottom}.ow-modal-header[data-v-32bfb7e2]{position:relative}.ow-modal-header .header[data-v-32bfb7e2]{background-color:#000;color:#cddc39;padding:15px}.ow-modal-header #icon[data-v-32bfb7e2]{position:absolute;left:10px;top:12px;color:#fff;cursor:pointer}.close-icon #icon[data-v-32bfb7e2]{top:6px;left:12px;z-index:999}.ow-modal-default-button[data-v-32bfb7e2]{float:right}.ow-modal-enter[data-v-32bfb7e2],.ow-modal-leave-active[data-v-32bfb7e2]{opacity:0}.ow-modal-enter .modal-container[data-v-32bfb7e2],.ow-modal-leave-active .modal-container[data-v-32bfb7e2]{transform:scale(1.1)}.modal-header[data-v-32bfb7e2]{background-color:#000;color:#cddc39;font-size:18px}.modal-body[data-v-32bfb7e2]{background-color:#fff;padding:10px}`,
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('transition', {
      attrs: {
        "name": "ow-modal"
      }
    }, [_c('div', {
      staticClass: "ow-modal-mask",
      class: [{
        'trans-bg': _vm.transBg
      }],
      style: ({
        zIndex: _vm.zIndex
      }),
      on: {
        "click": _vm.handleClose
      }
    }, [_c('div', {
      staticClass: "ow-modal-wrapper",
      class: _vm.position
    }, [_c('div', {
      staticClass: "ow-modal-container",
      style: ({
        width: _vm.width,
        maxWidth: _vm.maxWidth,
        height: _vm.height,
        maxHeight: _vm.maxHeight,
        overflow: _vm.containerOverflow
      }),
      on: {
        "click": _vm.handleClick
      }
    }, [_c('div', {
      staticClass: "ow-modal-header"
    }, [_vm._t("header", [_c('div', {
      staticClass: "modal-header"
    }, [_c('i', {
      staticClass: "close-icon",
      on: {
        "click": function($event) {
          return _vm.$emit('close')
        }
      }
    }, [(_vm.owRegistry['ow-icon']) ? _c('ow-icon', {
      attrs: {
        "name": "CROSS",
        "width": "20px"
      }
    }) : _vm._e()], 1)])])], 2), _vm._v(" "), _vm._t("body"), _vm._v(" "), _vm._t("footer")], 2)])])])
  },
  staticRenderFns: [],

  name: 'owModal',
  props: {
    position: {
      type: String,
      default: 'top'
    },
    bgClickClose: {
      type: Boolean,
      default: false
    },
    transBg: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: 'auto'
    },
    title: String,
    height: {
      type: String,
      default: 'auto'
    },
    maxHeight: {
      type: String,
      default: 'none'
    },
    maxWidth: {
      type: String,
      default: 'none'
    },
    containerOverflow: {
      type: String,
      default: 'auto'
    },
    zIndex: {
      type: Number,
      default: 100
    }
  },
  mounted: function mounted() {
    try {
      var isSafari = /constructor/i.test(window.HTMLElement) || function(p) {
        return p.toString() === "[object SafariRemoteNotification]";
      }(!window['safari'] || typeof safari !== 'undefined' && safari.pushNotification);
      var userAgent = window.navigator.userAgent;
      if (isSafari || userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
        var element = window.document.getElementById('icon');
        this.maxHeight = 'none !important';
        element.style.top = "35px";
      }
    } catch (ex) {
      console.log(ex);
    }
  },

  methods: {
    handleClose: function handleClose() {
      if (this.bgClickClose) {
        this.$emit('close');
      }
    },
    handleClick: function handleClick(event) {
      event.stopPropagation();
    }
  }

});